import {Component, inject, OnInit} from '@angular/core';
import {select, Store} from "@ngrx/store";
import {selectFilterStoreItem, selectStoreItems} from "../../../../store/entities/store-item/store-item.selectors";
import {StoreItemEntity} from "../../../../store/entities/store-item/store-item.model";
import {StoreItemActions} from "../../../../store/entities/store-item/store-item.actions";
import {GET_NEWS_ARTICLES} from "../../../../store/entities/cms/news-article/news-article.graphql";
import {Observable, Subscription} from "rxjs";
import {NewsArticle} from "../../../../store/entities/cms/news-article/news-article.model";
import {AppState} from "../../../../store/reducers";
import {environment} from "../../../../../environments/environment";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-news-detail-page',
  templateUrl: './news-detail-page.component.html',
  styleUrl: './news-detail-page.component.scss'
})
export class NewsDetailPageComponent implements OnInit {
  activeImageIndex = 0;

  carouselItems$: Observable<NewsArticle>
  topNews$: Observable<NewsArticle[]>
  store = inject(Store<AppState>);
  fileUrl = environment.FILE_SERVER_URL;
  activatedRoute = inject(ActivatedRoute);
  routeSub = Subscription.EMPTY;
  selectedUid: string;

  ngOnInit() {
    this.topNews$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.newsArticle)))

    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.newsArticle,
      query: GET_NEWS_ARTICLES,
      filtering: {
        itemsPerPage: 10
      }
    }))


    this.routeSub = this.activatedRoute.paramMap.subscribe(items => {
      this.selectedUid = items.get('uniqueId') as any;
      this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
        entity: StoreItemEntity.carouselItem,
        query: GET_NEWS_ARTICLES,
        filtering: {
          uniqueId: this.selectedUid
        }
      }))
      this.carouselItems$ = this.store.pipe(select(selectFilterStoreItem(StoreItemEntity.carouselItem, {uniqueId: this.selectedUid})))

    });

  }


}
